import { createSlice } from '@reduxjs/toolkit';
import {
  attachmentResetAlertHandler,
  attachmentGetGroupAttachmentsByGroupIds,
  downloadAttachmentById,
  attachmentCreateGroup,
  attachmentAddAttachmentToGroup,
  attachmentDeleteSingleAttachment,
} from './attachmentThunk';

const defaultPageSize = 9
const defaultActiveSummary = 'ALL'
const initialState = {
  loading: {
    fetch: false,
    mutate: false,
  },
  alert: {},
  pageNumber: 0,
  summaries: {},
  sortList: [],
  activeSort: {},
  filterList: [],
  activeFilters: {},
  pageSize: defaultPageSize,
  activeSummary: defaultActiveSummary,
  activeSearch: '',
  data: [],
  lookups: {},
  updatedItem: {},
  finalPage: true,
  attachment: {},
}

const attachmentSlice = createSlice({
  name: 'attachment',
  initialState,

  extraReducers: (builder) => {
    builder.addCase(attachmentResetAlertHandler.fulfilled, (state) => {
      state.alert = {}
    });

    builder.addCase(attachmentCreateGroup.pending, (state) => {
      state.alert = {}
      state.loading.mutate = true
    });

    builder.addCase(attachmentCreateGroup.rejected, (state, { payload }) => {
      state.alert = payload
      state.loading.mutate = false
    });

    builder.addCase(attachmentCreateGroup.fulfilled, (state) => {
      state.alert = {}
      state.loading.mutate = false
    });

    builder.addCase(attachmentAddAttachmentToGroup.pending, (state) => {
      state.alert = {}
      state.loading.mutate = true
    });

    builder.addCase(attachmentAddAttachmentToGroup.rejected, (state, { payload }) => {
      state.alert = payload
      state.loading.mutate = false
    });

    builder.addCase(attachmentAddAttachmentToGroup.fulfilled, (state) => {
      state.alert = {}
      state.loading.mutate = false
    });

    builder.addCase(downloadAttachmentById.pending, (state) => {
      state.alert = {}
      state.loading.fetch = false
      state.attachment = {}
    });

    builder.addCase(attachmentDeleteSingleAttachment.pending, (state) => {
      state.alert = {}
      state.loading.mutate = true
    });

    builder.addCase(attachmentDeleteSingleAttachment.rejected, (state, { payload }) => {
      state.alert = payload
      state.loading.mutate = false
    });

    builder.addCase(attachmentDeleteSingleAttachment.fulfilled, (state) => {
      state.alert = {}
      state.loading.mutate = false
    });

    builder.addCase(downloadAttachmentById.rejected, (state, { payload }) => {
      state.alert = payload
      state.loading.fetch = false
    });

    builder.addCase(downloadAttachmentById.fulfilled, (state, { payload }) => {
      state.alert = {}
      state.loading.fetch = false
      state.attachment = payload
    });

    builder.addCase(attachmentGetGroupAttachmentsByGroupIds.pending, (state) => {
      state.alert = {}
      state.loading.fetch = true
    });

    builder.addCase(attachmentGetGroupAttachmentsByGroupIds.rejected, (state, { payload }) => {
      state.alert = payload
      state.loading.fetch = false
    });

    builder.addCase(attachmentGetGroupAttachmentsByGroupIds.fulfilled, (state, { payload }) => {
      state.alert = {}
      state.loading.fetch = false
      state.lookups = payload.attachment_groups
    });
  },
})

export const selectAttachment = ({ attachment }) => attachment

export default attachmentSlice.reducer
